var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labelled-container"},[_c('div',{staticClass:"labelled-header",style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"labelled-body"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }